import { z } from "zod";
import { UuidSchema } from "./common.js";

// Spec 078 — Link de exibição da rota ambiente (TV do chão de fábrica). Token opaco de 32 bytes
// em base64url, mostrado UMA vez na geração; só o sha256 é gravado. Revogar é terminal.

export const DisplayTokenSummarySchema = z.object({
  id: UuidSchema,
  lineId: UuidSchema,
  label: z.string().nullable(),
  createdByName: z.string(),
  createdAt: z.string(),
  lastAccessAt: z.string().nullable(),
  revokedAt: z.string().nullable(),
});
export type DisplayTokenSummary = z.infer<typeof DisplayTokenSummarySchema>;

export const CreateDisplayTokenRequestSchema = z
  .object({ label: z.string().trim().min(1).max(60).optional() })
  .strict();
export type CreateDisplayTokenRequest = z.infer<typeof CreateDisplayTokenRequestSchema>;

/** O token em claro só existe nesta resposta (FR-039). */
export const CreateDisplayTokenResponseSchema = z.object({
  token: z.string(),
  /** Caminho RELATIVO da rota ambiente pública: `/display/<token>`. */
  url: z.string(),
  summary: DisplayTokenSummarySchema,
});
export type CreateDisplayTokenResponse = z.infer<typeof CreateDisplayTokenResponseSchema>;

/** 32 bytes em base64url = 43 chars; a faixa dá folga sem aceitar lixo. */
export const DisplayTokenValueSchema = z
  .string()
  .min(40)
  .max(64)
  .regex(/^[A-Za-z0-9_-]+$/);

export const DisplayTokenParamsSchema = z.object({ token: DisplayTokenValueSchema });
export const DisplayTokenIdParamsSchema = z.object({ lineId: UuidSchema, tokenId: UuidSchema });
export const DisplayModelFileParamsSchema = z.object({
  token: DisplayTokenValueSchema,
  modelId: UuidSchema,
});

// Envelopes (as rotas não importam `zod` — ADR-009).
export const DisplayTokenListEnvelopeSchema = z.object({
  data: z.array(DisplayTokenSummarySchema),
  error: z.null(),
});
export const DisplayTokenEnvelopeSchema = z.object({
  data: DisplayTokenSummarySchema,
  error: z.null(),
});
export const CreateDisplayTokenEnvelopeSchema = z.object({
  data: CreateDisplayTokenResponseSchema,
  error: z.null(),
});
